import { render, staticRenderFns } from "./AdminProductInventoryHistory.vue?vue&type=template&id=e50ea1c2"
import script from "./AdminProductInventoryHistory.vue?vue&type=script&lang=js"
export * from "./AdminProductInventoryHistory.vue?vue&type=script&lang=js"
import style0 from "./AdminProductInventoryHistory.vue?vue&type=style&index=0&id=e50ea1c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports